import { useDispatch } from 'react-redux';
import { store } from '../store/createStore';

type AppDispatch = typeof store.dispatch;
const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();

export default useAppDispatch;
